/**
 * Sizer / Final Sizer / Term Sheet workbooks (shape B — raw payload, no
 * envelope). The pass/fail cells live in `guideline_checks[]`
 * ({ sheet, cell, label, result }, eastview-os app/models/extract_models/sizer_docs.py)
 * — the spec's `gates[]` shape doesn't exist on the wire.
 */
const RESULT_TONE = { pass: "ok", fail: "crit" };

const sizerConfig = {
  id: "sizer",
  routes: ["sizer"],
  title: "Sizer",
  sections: [
    {
      kind: "table",
      id: "guideline-checks",
      title: "Guideline checks",
      path: "guideline_checks",
      titleKey: "label",
      columns: [],
      detail: ["sheet", "cell"],
      sortBy: { key: "result", rank: ["fail", "pass", "n/a"] },
      tags: (row) => {
        const r = String(row?.result || "").trim();
        if (!r) return [];
        const tone = RESULT_TONE[r.toLowerCase()] || "neutral";
        return [
          { label: tone === "ok" ? "Passed" : tone === "crit" ? "Failed" : r, tone },
          ...(row.sheet ? [{ label: `${row.sheet}${row.cell ? ` · ${row.cell}` : ""}`, tone: "neutral" }] : []),
        ];
      },
    },
    { kind: "auto", id: "full-workbook", title: "Full workbook", path: "full_workbook_pairs", defaultCollapsed: true },
  ],
  detailPaths: ["full_workbook_sheets"],
  rules: [
    {
      id: "sizer-failed",
      tone: "crit",
      when: { path: "guideline_checks", op: "anyRow", where: { path: "result", op: "eq", value: "Fail" } },
      title: "{count} sizer {count|plural:gate,gates} failed",
      target: { sectionId: "guideline-checks" },
    },
  ],
};

export default sizerConfig;
